import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// ─── Fill in your real social URLs here ──────────────────────────────────────
const SOCIAL = {
  instagram: "https://www.instagram.com/profio.platform/",
  tiktok:    "https://www.tiktok.com/@profio.platform",
  telegram:  "https://t.me/profioplatform",
};
// ─────────────────────────────────────────────────────────────────────────────

export default function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();
  const brand = "Profio";

  return (
    <footer className="border-t border-white/10">
      <div className="mx-auto max-w-6xl px-4 md:px-6 py-6">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div className="flex items-center gap-2">
            <span className="text-xl font-extrabold">profio</span>
            <span className="text-white/60">
              {t("footer.copyright", { year, brand })}
            </span>
          </div>

          <nav className="flex flex-wrap items-center gap-x-6 gap-y-2">
            <Link className="text-white/70 hover:text-white" to="/about">
              {t("footer.about")}
            </Link>
            <Link className="text-white/70 hover:text-white" to="/faq">
              {t("footer.faq", { defaultValue: "FAQ" })}
            </Link>
            <Link className="text-white/70 hover:text-white" to="/contact">
              {t("footer.contact")}
            </Link>
            <Link className="text-white/70 hover:text-white" to="/privacy">
              {t("footer.privacy")}
            </Link>
            <Link className="text-white/70 hover:text-white" to="/tos">
              {t("footer.tos", { defaultValue: "Terms" })}
            </Link>
            <Link className="text-white/70 hover:text-white" to="/cookies">
              {t("footer.cookies", { defaultValue: "Cookies" })}
            </Link>

            <div className="flex items-center gap-4">
              {SOCIAL.instagram && (
                <a
                  aria-label={t("footer.social.instagram")}
                  href={SOCIAL.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="opacity-80 hover:opacity-100"
                >
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                    <rect x="3" y="3" width="18" height="18" rx="5" stroke="white" strokeWidth="1.6" />
                    <circle cx="12" cy="12" r="4" stroke="white" strokeWidth="1.6" />
                    <circle cx="17.5" cy="6.5" r="1.2" fill="white" />
                  </svg>
                </a>
              )}
              {SOCIAL.tiktok && (
                <a
                  aria-label={t("footer.social.tiktok")}
                  href={SOCIAL.tiktok}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="opacity-80 hover:opacity-100"
                >
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                    <path d="M14 5c.6 1.7 2.2 3 4.1 3.2V11c-1.7-.1-3.3-.8-4.5-1.9V14a5 5 0 1 1-5-5c.5 0 1 .1 1.5.2V11a2.5 2.5 0 1 0 2.5 2.5V5h1.4Z" fill="white"/>
                  </svg>
                </a>
              )}
              {SOCIAL.telegram && (
                <a
                  aria-label={t("footer.social.telegram")}
                  href={SOCIAL.telegram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="opacity-80 hover:opacity-100"
                >
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                    <path d="M20.4 4.6 3.8 11.2c-.8.3-.8 1.5.1 1.7l4.1 1.2 1.6 4.9c.2.7 1.1.8 1.6.3l2.3-2.3 4.1 3c.6.4 1.5.1 1.7-.6l3-13c.2-.9-.6-1.6-1.5-1.3Z" fill="white"/>
                  </svg>
                </a>
              )}
            </div>
          </nav>
        </div>
      </div>
    </footer>
  );
}
